import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Helmet } from "react-helmet";

import Navbar from '../../Shared/Components/Navbar';
import MlsIdForm from '../Components/MlsIdForm';
import PersonalInfoForm from '../Components/PersonalInfoForm';
import { checkingMlsSelector, mlsIdSelector } from '../../../Reducers/SellerNotificationReducer';
import Footer from '../../Shared/Components/Footer';
import { sellerNotificationActionCreators } from '../../../Actions/SellerNotificationActions';
import { useParams } from 'react-router';
import { Spinner } from 'react-bootstrap';
import { useTitle } from '../../../Utilities/Hooks';


const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 3rem;
  align-items: baseline;
  justify-content: flex-start;
  padding-right: 0.5rem
  padding-left: 0.5rem
  min-height: 400px;

  @media(min-width: ${({ theme }) => theme.breakpoints.sm}){
    padding-right: 1.5rem
    padding-left: 1.5rem
  }
`;

const Text = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 0.25rem;
  color: ${({ error }) => error ? '#E53E3E': 'inherit'};
`;

const Loader = styled(Spinner)`
    color: ${({ theme }) => theme.dark};
    align-self: center;
    margin: 4px;
`;

const ShowingRequest = () => {
  const dispatch = useDispatch();
  const mlsId = useSelector(mlsIdSelector);
  const checkingMls = useSelector(checkingMlsSelector);

  const { mlsid: paramsMlsid } = useParams();
  useTitle('Request a showing | Unreal Estate');
  
  useEffect(() => {
    if (paramsMlsid && paramsMlsid !== mlsId) {
      dispatch(sellerNotificationActionCreators.сheckMls(paramsMlsid));
    }
  }, [paramsMlsid])

  return (
    <>
        <Helmet>
          <meta name="description" content="We’re making it easier to buy or sell unreal homes. Request a showing time on a property listed by Unreal Estate today."/>
				</Helmet>
      <Navbar/>
      <ContentContainer>
      <h1>Request a showing</h1>
        {!paramsMlsid ? (
          <>
            <Text>Enter the MLS ID of the property you wish to request a showing.</Text>
            <MlsIdForm/>
          </>
        ) : (
          <>
            {mlsId ? (
              <Text>
                {checkingMls ? (
                  <Loader animation="border" size="sm" />
                ) : (
                  <Text>MLS id: {mlsId}</Text>
                )}
              </Text>
            ) : (
              <Text error>MLS not found</Text>
            )}
            <PersonalInfoForm/>
          </>
        )}
      </ContentContainer>
      <Footer/>
    </>
  );
}; 

export default ShowingRequest;